module.exports = __webpack_public_path__ + "img/box6-18.65ed984b.png";